<template>
    <a
        v-if="props.externalTo"
        :href="externalTo"
        :class="[$style.baseLink, props.disabled ? $style.disabled : '']"
    >
        <slot />
    </a>
    <RouterLink
        v-else-if="computedTo"
        :to="computedTo"
        :class="[$style.baseLink, props.disabled ? $style.disabled : '']"
    >
        <slot />
    </RouterLink>
</template>

<script lang="ts" setup>
import { AnchorHTMLAttributes, computed } from 'vue'
import { RouteLocationRaw, RouterLink } from 'vue-router'

import { useGetExternalUrl } from '@/composables/url-helpers'

export interface BaseLinkProps extends /* @vue-ignore */ AnchorHTMLAttributes {
    disabled?: boolean
    to?: RouteLocationRaw
    externalTo?: string
}

const props = defineProps<BaseLinkProps>()
const getExternalUrl = useGetExternalUrl()

const computedTo = computed(() => {
    if (props.target === '_blank' && props.to) {
        return getExternalUrl(props.to)
    }
    return props.to
})
</script>

<style module>
.baseLink.disabled,
.baseLink.disabled:hover,
.baseLink.disabled:focus-within {
    cursor: default;
}
</style>
